import { Variant } from '../types';

export const forwarderImport: Variant = {
  'messageInfo.methodOfPayment': { present: false },
  'messageInfo.deferredPayment': { present: false },
  'messageInfo.methodOfPaymentVAT': { present: false },
  'messageInfo.deferredPaymentVAT': { present: false },
};
